import React from "react";
import PickProgress from "../../PickProgress";
import styles from "./parts.module.css";

type Props = {
  isLoading: boolean;
  isCancelled: boolean;
  data: {
    itemId: number;
    confirmedQuantity: number;
    pickedQuantity: number;
    adjustedPickedQuantity: number;
    remainingQuantity: number;
    verifiedQuantity: number;
  };
  actions: {
    onIncreaseAdjustedPick: (itemId: number) => void;
    onDecreaseAdjustedPick: (itemId: number) => void;
    onConfirmExcessPicks: (conveyorBoxItemID: number) => void;
    onAutoVerifyQuantity: (itemId: number) => void;
  };
};

const BoxItemPickProgress = ({ isLoading, isCancelled, data, actions }: Props) => {
  return (
    <div className={styles["pick-progress-container"]}>
      <PickProgress isLoading={isLoading} disabled={isCancelled} data={data} actions={actions} />
    </div>
  );
};

export default BoxItemPickProgress;
